import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-9808 4K (QFHD) Schnellinstallation",
  "path": "/Aussenkameras/IN-9808_QFHD/Schnell_Installation/",
  "dateChanged": "2018-01-22",
  "author": "Mike Polinowski",
  "excerpt": "IN-9808 4K (QFHD) Schnellinstallation",
  "image": "./P_SearchThumb_IN-9008HD_Quick_Installation.png",
  "social": "/images/Search/P_SearchThumb_IN-9408WQHD_Quick_Installation.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const NavButtons = makeShortcode("NavButtons");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title="IN-9808 4K (QFHD) Schnellinstallation" dateChanged="2018-01-22" author="Mike Polinowski" tag="INSTAR IP Camera" description="IN-9808 4K (QFHD) Schnellinstallation" image="/images/Search/P_SearchThumb_IN-9408HD_Quick_Installation.png" twitter="/images/Search/P_SearchThumb_IN-9408HD_Quick_Installation.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9808_QFHD/Quick_Installation/" locationFR="/fr/Outdoor_Cameras/IN-9808_QFHD/Quick_Installation/" crumbLabel="Installation" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "wählen-sie-ihr-kameramodell",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#w%C3%A4hlen-sie-ihr-kameramodell",
        "aria-label": "wählen sie ihr kameramodell permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wählen Sie ihr Kameramodell`}</h2>
    <p>{`Dieser Installationsassistent hilft Ihnen bei den ersten Schritten der Installation einer INSTAR WQHD 2k+ Kamera. Hierbei wird bei der Erstkonfiguration unterschieden ob Sie per LAN oder WLAN auf die Kamera zugreifen. Und bei der Montage ob Sie die Kamera per Netzteil oder PoE mit Strom versorgen, ob die Kamera per LAN Kabel angebunden ist oder WLAN und ob Sie zusätzliche Periepherie an Ihrer Kamera anschließen möchten (z.B. einen externen Lautsprecher):`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://install.instar.de/QFHD/install_9808.html?lang=de"
        }}>{`INSTAR KAMERA-INSTALLATIONS-ASSISTENT`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      